module.exports = __webpack_public_path__ + "img/Logo_FC_Liverpool.2be56306.png";